import type { RouteObject } from 'react-router';

import * as searchInternshipsHorizonRouteExports from '#/modules/search/internships/page/SearchInternships.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchInternshipsRoutePaths } from './searchInternships.route-paths';

const searchInternshipsRouteObject = horizonRouteToObject(
  searchInternshipsHorizonRouteExports,
);
const createSearchInternshipsRouteObject = (path: string): RouteObject => ({
  path,
  ...searchInternshipsRouteObject,
});

export const searchInternshipsRouteObjects = searchInternshipsRoutePaths.map(
  createSearchInternshipsRouteObject,
) satisfies RouteObject[];
